export default class {
    constructor(Component) {
        this.Component  = Component;
        this.container  = Component.container.querySelector('.box-listing-slider');
    }

    get width() {
        return this.container.offsetWidth;
    }

    get position() {
        return this.container.scrollLeft;
    }

    scrollNext() {
        this.scroll(this.position + this.width / 2);
        return this;
    }

    scrollPrev() {
        this.scroll(this.position - this.width / 2);
        return this;
    }

    scroll(position) {
        $(this.container).animate({ scrollLeft: position }, this.Component.transition.duration);
        return this;
    }

    bind() {
    }
}
